import apiClient from './api';
import {
  InventoryOpeningBalance,
  CreateInventoryOpeningBalanceDto,
  UpdateInventoryOpeningBalanceDto,
  InventoryOpeningBalanceSummary,
} from '../types/inventoryOpeningBalances.types';

const BASE_URL = '/InventoryOpeningBalances';

export const inventoryOpeningBalancesService = {
  getAll: async (): Promise<InventoryOpeningBalance[]> => {
    const response = await apiClient.get(BASE_URL);
    return response.data;
  },

  getById: async (id: number): Promise<InventoryOpeningBalance> => {
    const response = await apiClient.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  create: async (dto: CreateInventoryOpeningBalanceDto): Promise<InventoryOpeningBalance> => {
    const response = await apiClient.post(BASE_URL, dto);
    return response.data;
  },

  update: async (id: number, dto: UpdateInventoryOpeningBalanceDto): Promise<InventoryOpeningBalance> => {
    const response = await apiClient.put(`${BASE_URL}/${id}`, dto);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`${BASE_URL}/${id}`);
  },

  generateDocumentNumber: async (): Promise<string> => {
    const response = await apiClient.get(`${BASE_URL}/generate-number`);
    return response.data.documentNumber;
  },

  post: async (id: number): Promise<InventoryOpeningBalance> => {
    const response = await apiClient.post(`${BASE_URL}/${id}/post`);
    return response.data;
  },

  unpost: async (id: number): Promise<InventoryOpeningBalance> => {
    const response = await apiClient.post(`${BASE_URL}/${id}/unpost`);
    return response.data;
  },

  // للقيد الافتتاحي - جلب ملخص قيم المخزون
  getSummaryForOpeningEntry: async (fiscalPeriodId?: number): Promise<InventoryOpeningBalanceSummary[]> => {
    const params = fiscalPeriodId ? { fiscalPeriodId } : {};
    const response = await apiClient.get(`${BASE_URL}/summary-for-opening-entry`, { params });
    return response.data;
  },
};